module.exports = function getResource(label, vars = []) {
    let resources = {
        status: 'Statut',
        seeTrackingDetails: 'Voir les détails de suivi',
        shippingMethod: 'Mode d’expédition',
        estimatedDelivery: 'Livraison estimée',
        tracking: 'N° de suivi :',
        shipTo: 'Expédier à',
        billingInfo: 'Infos de facturation',
        paypalAccount: 'Compte PayPal',
        applePay: 'Apple Pay',
        shipment: 'EXPÉDITION',
        needToReturnSomething: 'Vous devez retourner quelque chose?',
        changedYourMind: 'Vous avez changé d’avis?',
        cancelYourOrder: 'Annulez votre commande',
        paidWith: 'Payé avec '
    };

    return resources[label];
};
